import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCookie } from '@/utils/cookies';
import { useGetClientQuery } from '@/queries/useGetClientQuery';
import { useGetClientsArrQuery } from '@/queries/useGetClientsArrQuery';
import { closeAccordion } from '@/redux/slices/interfaceSlice';

export const useHederProfileBlock = () => {
  interface UserInfo {
    fullName: string;
    id: string;
  }
  const dispatch = useDispatch();

  const userTokens: Array<string> = (() => {
    try {
      const tokens = getCookie('user_tokens');
      return tokens ? JSON.parse(tokens) : [];
    } catch (e) {
      console.error('Error parsing user_tokens:', e);
      return [];
    }
  })();
  const { closeAccordionState } = useSelector((state: any) => state.interfaceApp);
  const { data: clientData, isPending, error } = useGetClientQuery();
  const { data: clientsResponses } = useGetClientsArrQuery(userTokens);

  const userId: string = useMemo(() => {
    if (clientData) return `${clientData.id}`;
    return '';
  }, [clientData]);

  const firstLetter: string = useMemo(() => {
    if (clientData) return `${clientData.name.charAt(0).toUpperCase()}`;
    return '';
  }, [clientData]);

  const userNames = useMemo<UserInfo[]>(() => {
    if (!clientsResponses) return [];

    return clientsResponses.map((response) => {
      const { name, last_name, id } = response.data;
      return {
        fullName: `${name} ${last_name}`,
        id: id,
      };
    });
  }, [clientsResponses]);

  const [selectedUserId, setSelectedUserId] = useState(userId);
  useEffect(() => {
    setSelectedUserId(userId);
  }, [userId]);

  const closeAccordionToggle = () => {
    dispatch(closeAccordion(closeAccordionState * -1));
  };

  if (isPending)
    return {
      userName: '',
      userNames,
      firstLetter: '',
      userTokens,
      selectedUserId,
      setSelectedUserId,
      isLoading: true,
      closeAccordionToggle,
    };

  if (error)
    return {
      userName: 'Ошибка загрузки имени',
      userNames,
      firstLetter: '',
      userTokens,
      selectedUserId,
      setSelectedUserId,
      isLoading: false,
      closeAccordionToggle,
    };
  return {
    userNames,
    firstLetter,
    userTokens,
    selectedUserId,
    setSelectedUserId,
    isLoading: false,
    closeAccordionToggle,
  };
};
